import PostMarkdown, { getOnlyStrings } from './PostMarkdown'
import utils, { covertTimestampISO } from '../utils'
import { unified } from 'unified'
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks'
import rehypeRaw from 'rehype-raw'
import remarkParse from 'remark-parse'
import { EditorButton } from './EditorButton'


function ArticleViewBase({ article, showEditorNav = false }: { article: Record<string, any>, showEditorNav?: boolean }) {

    // const [headers, setHeaders] = useState<string[] | null>(null)
    function extractHeaders() {
        const tree = unified().use(remarkParse).use(remarkGfm).use(remarkBreaks).use(rehypeRaw).parse(article.content || "");
        const tempHeaders: string[] = []

        tree.children.forEach((node: any, index: number) => {
            if (node.type === "heading") {
                const text = getOnlyStrings(node.children)
                if (text.replace(/ /g, "").replace(/^\s+/, "") !== "") {
                    tempHeaders.push(getOnlyStrings(node.children))
                }
            }
        })
        // setHeaders(tempHeaders)
        return tempHeaders
    }
    const headers = extractHeaders()

    return <div className='relative'>
        {article["published_at"] == null && <div className='text-white font-semibold block p-2 px-4 bg-orange-500 w-[calc(100%_+_2rem)] -m-4 mb-4'>
            <b>DRAFT:</b> This article is still in the works and has yet to be published.
        </div>}

        <div className='flex flex-wrap justify-between pb-1'>
            <div className='pb-1'>
                <EditorButton src='/images/rewind.png' label='View history' to={`/history/${article["article_id"]}`} />
                {showEditorNav && <EditorButton src='/images/pencil.png' label='Edit' to={`/edit/${article["article_id"]}`} />}
            </div>
            <div>
                {article.tags && article.tags.map((tag: any) => {
                    return <span key={tag.id} className='inline-block bg-darkPrimary px-4 py-1 ml-1 rounded-full text-white'>
                        {tag.name}
                    </span>
                })}
            </div>
        </div>
        <div className='flex flex-row-reverse items-center justify-between flex-wrap mb-3'>
            <div className='text-right'>
                <span
                    className='block align-middle text-xs font-semibold'
                    children={`Created at ${utils.timeFromTimestamp(covertTimestampISO(article["created_at"]), true)}`}
                />
                <span
                    className='align-middle text-xs font-semibold'
                    children={`${article["published_at"] ? `Published at ${utils.timeFromTimestamp(covertTimestampISO(article["published_at"]), true)}` : ''}`}
                />
            </div>
            <h2 className='text-3xl font-semibold mb-2'>{article.title}</h2>
        </div>
        <PostMarkdown
            body={article.content || ""}
        />
        {/* {headers && <aside className='text-right absolute -right-4 -top-4 -bottom-4 p-4 bg-darkPrimary text-white phones:-left-4'>
            <div className='sticky top-0 bottom-0'>
                <h2 className='text-lg font-semibold mb-2'>Contents</h2>
                {headers.map((heading, index) => (
                    <Link
                        key={index}
                        to={`#${heading.toLocaleLowerCase().replace(/ /g, "-")}`}
                        className='block'
                        children={heading}
                    />
                ))}
            </div>
        </aside>} */}
    </div>
}

export default ArticleViewBase